import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "../themes/index-1/Home";
import AvisoDePrivacidad from "../pages/AvisoDePrivacidad";
import NotFound from "../components/others/NotFound";
import ScrollToTop from "./ScrollToTop";

const AppRoutes = () => {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/aviso-de-privacidad" element={<AvisoDePrivacidad />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
};

export default AppRoutes;
